<div *ngIf="quote">
    <p><strong>Quote ID:</strong> {{ quote.id }}</p>
    <p><strong>Quote Reference:</strong> {{ quote.quote_number }}</p>
    <p><strong>Quote Status:</strong> {{ quote.quote_status }}</p>
    <p><strong>Quote Amount:</strong> {{ quote.quote_total }}</p>
  </div>